import * as React from "react";
import classNames from "classnames";
import { Spinner } from "react-bootstrap";

interface Props {
    className?: string;
    size?: "sm";
    color?: string;
    noMargin?: boolean;
}

export function Loading(props: Props) {
    const color = props.color ?? "primary";
    const size = props.size;
    return (
        <section
            role="loader"
            className={classNames(
                "flex-grow-1 d-flex flex-row flex-center my-6",
                { "my-6": !props.noMargin },
                props.className
            )}
            data-testid="loader"
        >
            <Spinner variant={color} size={size} />
        </section>
    );
}
